// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.analytic_biogenic_amines_sample_type_enum */
var AnalyticBiogenicAminesSampleTypeEnum;
(function (AnalyticBiogenicAminesSampleTypeEnum) {
    AnalyticBiogenicAminesSampleTypeEnum["liquid"] = "liquid";
    AnalyticBiogenicAminesSampleTypeEnum["powder"] = "powder";
})(AnalyticBiogenicAminesSampleTypeEnum || (AnalyticBiogenicAminesSampleTypeEnum = {}));
;
export default AnalyticBiogenicAminesSampleTypeEnum;
/** Zod schema for analytic_biogenic_amines_sample_type_enum */
export const analyticBiogenicAminesSampleTypeEnum = z.nativeEnum(AnalyticBiogenicAminesSampleTypeEnum);
//# sourceMappingURL=AnalyticBiogenicAminesSampleTypeEnum.js.map